const REQUIRED_PASS = 'Por favor crea una nueva contraseña. Incluye al menos 8 caracteres, un número, una letra mayúscula y un símbolo especial.'
const FAILED_TO_FETCH = 'Ocurrió un problema al solicitar la información.'
const NO_DATA_FOR_QUERY = 'No se encontró información para la consulta.'

export {
  REQUIRED_PASS,
  FAILED_TO_FETCH,
  NO_DATA_FOR_QUERY,
}